export default __webpack_public_path__ + "static/background-e0e4852659de67e93809972ca5df8410.png";